import { css } from '@emotion/react';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  type ReactNode, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { MetricInferenceSourceDataLayerTagComponent } from '~/_shared/components/metricsList/item/metricInferenceSourceDataLayerTag.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { openMapTool } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';

export const metricsDataLayerBannerTextStyle = css({
  fontSize: 13,
  padding: 0,
  margin: 0,
});

const listItemStyle = css({
  padding: '8px 14px',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

const headerStyle = css({
  display: 'inline-flex',
  flexWrap: 'nowrap',
  fontSize: 15,
  gap: 4,
  alignItems: 'center',
  justifyContent: 'space-between',
});

const headingStyle = css({
  padding: 0,
  margin: 0,
});

const headerContentPrimaryStyle = (theme: Theme) => css({
  display: 'flex',
  gap: 8,
  color: theme.textColors.secondary,
  textTransform: 'uppercase',
});

type MetricsDataLayerBannerProps = Readonly<{
  children: ReactNode;
  heading: string;
  icon: IconProp;
  iconStyle?: (theme: Theme) => ReturnType<typeof css>;
}>;

export const MetricsDataLayerBannerComponent = ({ children, heading, icon, iconStyle }: MetricsDataLayerBannerProps) => {
  const dispatch = useDispatch();

  const openDataLayersTool = useCallback(() => {
    dispatch(openMapTool(MapTool.DataLayers));
  }, [dispatch]);

  return (
    <div css={listItemStyle}>
      <div css={headerStyle}>
        <div css={headerContentPrimaryStyle}>
          <FontAwesomeIcon
            css={iconStyle}
            icon={icon}
          />
          <p css={headingStyle}>{heading}</p>
        </div>

        <MetricInferenceSourceDataLayerTagComponent onDataLayerClick={openDataLayersTool} />
      </div>

      {children}
    </div>
  );
};
